<template>
    <c-dialog ref="dialog" width="550" mode="slide" mask-close @close="dialogFormEditConfirm($refs.form, arguments)" @resolve="editHandle">

        <c-form ref="form" vertical unit-width="100%">
            <c-input type="hidden" name="id"></c-input>

            <c-form-item label="网点名称" required>
                <c-input name="outlet_name" maxlength="255"></c-input>
            </c-form-item>

            <c-form-item label="网点位置" required>
				<c-location lng-name="longitude" lat-name="latitude" address-name="outlet_address"></c-location>
            </c-form-item>

            <c-form-item label="网点负责人">
                <c-select name="principal_user_id" async @search="searchUser" :value-data="selectedUser" clearable>
                    <template #option="{data, selected}">
                        <select-option
                                :name="data.name"
                                :info="[
                                `${data.data.department_name || ''} | ${data.data.position_name || ''}`
                            ]"
                                :selected="selected"
                        ></select-option>
                    </template>
                </c-select>
            </c-form-item>

            <c-form-item label="状态" required>
                <c-radio-group name="status" :options="disableEnableDic"></c-radio-group>
            </c-form-item>

            <c-form-item label="备注">
                <c-input name="remark" type="textarea" maxlength="1000"></c-input>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>
import {mapState} from "vuex";
export default {
    computed: {
        // 获取dictName选项数据
        ...mapState(['disableEnableDic'])
    },
    data() {
        return {
            selectedUser:[],
            editState: false
        }
    },

    methods: {
        /*********打开编辑框，初始化**********/
        async open(data) {
            this.$refs.form.clear();
            this.selectedUser = [];
            this.editState = false;
            if (data) {
                //查询网点详情
                this.request({
                    url:'/aftersale/outlet/detail',
                    data: {
                        id:data.id
                    },
                    success:data => {
                        this.$refs.form.set(data);
                        //已选中的负责人
                        if(data.principal_user_id && data.principal_user_name){
                            this.selectedUser = [{
                                name: data.principal_user_name,
                                value: data.principal_user_id
                            }];
                        }
                    }
                });
                this.editState = true;
            }else{
                this.$refs.form.set({
                    status: 1
                });
            }
            //填充 form 表单
            this.$refs.dialog.open({
                title: data ? '编辑服务网点' : '新增服务网点'
            });
        },

        /*******搜索用户*****************/
        searchUser(keyword, resolve){
            this.request({
                url:'/system/options',
                data: {
                    options_code:'SYSUSER',
                    keyword:keyword
                },
                success:data => {
                    resolve(data);
                }
            })
        },
        /*******创建、编辑提交处理方法********/
        editHandle (stop, next){
            stop();
            this.$refs.form.submit({
                url: this.editState?'/aftersale/outlet/update':'/aftersale/outlet/insert',
                rule: {
                    outlet_name: '请输入网点名称',
                    outlet_address: '请输入网点地址',
                    longitude: '请输入网定位经度',
                    latitude: '请输入网定位纬度'
                },
                dataFormatter: data => {
                    return data;
                },
                success: (data, res) => {
                    next();
                    if (this.editState){//编辑
                        this.$message({
                            message: '编辑成功',  // 提示内容,
                            type: 'success'
                        });
                    }else {//新增
                        this.$message({
                            message: '新增成功',  // 提示内容,
                            type: 'success'
                        });
                    }
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>
